var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowRight1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "24px",
    viewBox: "0 0 16 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Assets / Icons / Bold / Arrow / arrow-right-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DS_Suez_PCE_Atoms",
    transform: "translate(-178.000000, -721.000000)",
    fill: "#030F40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-fill-color",
    transform: "translate(174.000000, 721.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5000018,12 C19.500819,12.6617023 19.2166089,13.2917013 18.72,13.729 L7.568,23.54 C6.79940904,24.1849293 5.65652679,24.098329 4.99389062,23.3449505 C4.33125444,22.591572 4.39124184,21.4469844 5.129,20.767 L14.881,12.188 C14.9351547,12.1405308 14.9662092,12.0720143 14.9662092,12 C14.9662092,11.9279857 14.9351547,11.8594692 14.881,11.812 L5.129,3.233 C4.39124184,2.55301564 4.33125444,1.40842796 4.99389062,0.655049482 C5.65652679,-0.0983289982 6.79940904,-0.184929277 7.568,0.46 L18.716,10.268 C19.213811,10.7060475 19.4993703,11.3369004 19.5000018,12 Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight1);
export default __webpack_public_path__ + "static/media/arrow-right-1.b1e9c77c.svg";
export { ForwardRef as ReactComponent };